module.exports = __webpack_public_path__ + "static/media/cross__red.a10b03ec.svg";